import { render } from "./GlobalPrefsDialog.vue?vue&type=template&id=992314ac&scoped=true"
import script from "./GlobalPrefsDialog.vue?vue&type=script&lang=js"
export * from "./GlobalPrefsDialog.vue?vue&type=script&lang=js"

import "./GlobalPrefsDialog.vue?vue&type=style&index=0&id=992314ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-992314ac"]])

export default __exports__